module.exports = __webpack_public_path__ + "static/from-scratch-af58d19d904af911cc73c74c769fc208.jpg";